import React from 'react';
import { X } from 'lucide-react';

const ForgotPasswordModal = ({ 
  show,
  onClose,
  resetEmail,
  setResetEmail,
  resetMessage,
  resetError,
  handleForgotPassword 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
      <div data-testid="forgot-password-modal" className="bg-gradient-to-br from-gray-900 to-black border-2 border-electric rounded-xl max-w-md w-full p-8">
        
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-electric mb-2">
            🔑 Reset Password
          </h2>
          <p className="text-gray-400">
            Enter your email to receive a password reset link
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleForgotPassword} className="space-y-4">
          
          {/* Email Input */}
          <div>
            <label className="block text-white font-bold mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              placeholder="your@email.com"
              className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border-2 border-white/20 focus:border-electric focus:outline-none"
              autoFocus
            />
          </div>

          {/* Success Message */}
          {resetMessage && (
            <div className="bg-green-500/20 border border-green-400 rounded-lg p-4 text-center">
              <p className="text-green-400 font-bold">✅ {resetMessage}</p>
            </div>
          )}

          {/* Error Message */}
          {resetError && (
            <div className="bg-red-500/20 border border-red-400 rounded-lg p-4 text-center">
              <p className="text-red-400 font-bold">❌ {resetError}</p>
            </div>
          )}

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              type="submit"
              className="flex-1 btn btn-electric text-lg"
            >
              Send Reset Link
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 btn btn-ghost text-lg"
            >
              Cancel
            </button>
          </div>
        </form>

        {/* Help Text */}
        <p className="text-gray-400 text-xs text-center mt-4">
          You'll receive an email with instructions to reset your password
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
